// Generated by CoffeeScript 2.7.0
var NextVertexAssignmentSetting;

import Popover from 'trunks/vue/admin/components/libs/popover.js';

import NextVertexSettingMixin from 'trunks/vue/share/mixins/yet_another_workflow/assignment_settings/next_vertex.js';

import {
  PopoverGroupOptionsMixin
} from 'trunks/vue/admin/components/popover_group_options.js';

export var ListSelect = {
  mixins: [PopoverGroupOptionsMixin],
  components: {
    'Popover': Popover
  },
  props: {
    initValue: {
      type: Object
    },
    extendClass: {
      type: String
    },
    optionList: {
      type: Array
    },
    placeholder: {
      type: String,
      default: '请选择'
    }
  },
  data: function() {
    return {
      select: this.initValue || null
    };
  },
  template: `<Popover position='bottom left'
         :caret='false'
         :customClass='extendClass'
         type='select'
         size='default'
         ref='popover'
         :blockContent='true'>
  <template slot='trigger'>
    <slot name='trigger'>
      <div class="input-control right-addon">
        <div class="controlled-input" v-if='select'>{{ displayValue }}</div>
        <div class="controlled-input placeholder" v-else>{{ placeholder }}</div>
        <div class="addon">
          <i class="slp-caret-down"></i>
        </div>
      </div>
    </slot>
  </template>
  <template slot='content'>
    <popover-group-options :formatDataFunc='formatOptionFunc'
                           :initialSelectedOptionIds='selectOptionIds'
                           :needFilterInput='false'
                           :needFooter='false'
                           @valueChanged='valueChangedFunc'
                           ref='popoverGroupOptionsRef'>
      <template slot='option-item-template' slot-scope='{ option }'>
        <div class='content'>{{ option.name }}</div>
        <div class='tip icon'>
          <i :class="option._selected ? 'slp-check' : 'slp-empty'"></i>
        </div>
      </template>
    </popover-group-options>
  </template>
</Popover>`,
  computed: {
    displayValue: function() {
      var ref;
      return (ref = this.select) != null ? ref.name : void 0;
    },
    selectOptionIds: function() {
      var ref;
      return [(ref = this.select) != null ? ref.id : void 0];
    }
  },
  watch: {
    optionList: function() {
      return this.$nextTick(function() {
        var ref;
        return (ref = this.$refs.popoverGroupOptionsRef) != null ? ref.reset() : void 0;
      });
    },
    initValue: function(new_value) {
      return this.select = new_value;
    },
    select: function(new_value) {
      return this.$emit('valueChanged', new_value);
    }
  },
  methods: {
    formatOptionFunc: function() {
      return [
        {
          options: this.optionList
        }
      ];
    },
    valueChangedFunc: function(new_option) {
      if (!new_option._selected) {
        new_option._selected = true;
        this.$refs.popover.close();
        return;
      }
      _.each(this.$refs.popoverGroupOptionsRef.groupedOptions, function(group) {
        return _.each(group.options, function(option) {
          if (option === new_option) {
            return;
          }
          return option._selected = false;
        });
      });
      this.select = new_option;
      return this.$refs.popover.close();
    }
  }
};

export default NextVertexAssignmentSetting = {
  mixins: [NextVertexSettingMixin],
  components: {
    'list-select': ListSelect
  },
  template: `<div class="form-field inline next-vertex-setting">
  <div class="form-field-head">
    <div class="form-field-title">选择下一节点</div>
  </div>
  <div class="form-field-input-container">
    <div class="form-field-input">
      <list-select :optionList='vertexlist'
                   :initValue='nextVertex'
                   extendClass='list-popover'
                   placeholder='任意'
                   @valueChanged='vertexSelectFunc' />
    </div>
  </div>
</div>`
};
